export default "__VITE_ASSET__eaaccc7d__"